var React = require('react');

function RedEye (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,2.5C4.4,2.5,1.3,4.8,0,8c1.3,3.2,4.4,5.5,8,5.5s6.7-2.3,8-5.5C14.7,4.8,11.6,2.5,8,2.5z M8,11.6C6,11.6,4.4,10,4.4,8\n\tS6,4.4,8,4.4S11.6,6,11.6,8S10,11.6,8,11.6z M8,5.8c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S9.2,5.8,8,5.8z","fill":"currentColor"}));
}

RedEye.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = RedEye;

RedEye.default = RedEye;
